import React from 'react'
import { clsx } from '../../utils/helper'

const Button = ({
    children,
    className = '',
    disabled,
    large,
    outline,
    fullWidth,
    small,
    style,
    ...props
}) => {
    const classes = clsx([
        'app-button label-1',
        outline && 'outline',
        disabled && 'disabled',
        large && 'large',
        fullWidth && 'full-width',
        small && 'small',
        className,
    ])

    return (
        <button className={classes} disabled={disabled} style={style} {...props}>
            {children}
        </button>
    )
}

export default Button
